import React from 'react';

const TagPermission = (props) => {
    let label = (
        <label className="label label-default">{props.descripcion}
            <span className="glyphicon glyphicon-remove" 
                title="Quitar este permiso."
                onClick={() => props.removeFuncion(props.permisoId, props.id)}>
            </span>
        </label>
    );

    return (
        <li className="no-bullets">
            {props.flag && <big>{label}</big>}
            {!props.flag && <big><del>{label}</del></big>}
        </li>
    );
}

export default TagPermission;